// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import Select2, { DataSelect2 } from 'wdna-select2';

import { LovDO, TypeSensorDO } from '../../requests';

interface Props {
  formValues: {
    data: Partial<TypeSensorDO>;
    typeModuleArray: LovDO[];
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
}

export default class Form extends React.Component<Props> {
  public render(): JSX.Element {
    const { onChange, formValues } = this.props;
    const { typeModuleArray, data } = formValues;

    return (
      <fieldset>
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Module</b> &nbsp;
            </label>
            <span className="mandatory">
              <Select2
                id="data.typeModuleId"
                name="data.typeModuleId"
                value={data.typeModuleId}
                onChange={onChange}
                data-ctype="number"
                data={typeModuleArray.map((item: LovDO): DataSelect2 => {
                  return { id: +item.id, text: item.name };
                })}
                options={{ placeholder: 'Select option' }}
                style={{ width: '80%' }}
                required
              />
            </span>
          </div>
          <div className="col-6">
            <label className="label">
              &nbsp;
            </label>
            <input
              type="checkbox"
              id="data.active"
              name="data.active"
              checked={data.active || false}
              onChange={onChange}
              className="input-new"
            />
            &nbsp;&nbsp;
            <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
              Active
            </label>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Code</b> &nbsp; &nbsp; &nbsp;&nbsp;
            </label>
            <input
              type="text"
              id="data.code"
              name="data.code"
              value={data.code}
              onChange={onChange}
              className="input-mandatory"
              style={{ width: '80%' }}
              placeholder="Code"
              required
            />
          </div>
          <div className="col-6">
            <label className="label">
              <b>Name</b> &nbsp; &nbsp;
            </label>
            <input
              type="text"
              id="data.name"
              name="data.name"
              value={data.name}
              onChange={onChange}
              className="input-mandatory"
              style={{ width: '80%' }}
              placeholder="Name"
              required
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Type</b> &nbsp; &nbsp; &nbsp;&nbsp;
            </label>
            <input
              type="text"
              id="data.type"
              name="data.type"
              value={data.type}
              onChange={onChange}
              className="input-mandatory"
              style={{ width: '80%' }}
              placeholder="Type"
              required
              maxLength={3}
            />
          </div>
          <div className="col-6">
            <label className="label">
              <b>Version</b> &nbsp; &nbsp;
            </label>
            <input
              type="number"
              id="data.vers"
              name="data.vers"
              value={data.vers || 1}
              onChange={onChange}
              data-ctype="number"
              className="input-mandatory"
              style={{ width: '150px' }}
              placeholder="Version"
              required
            />
          </div>
        </div>
      </fieldset>
    );
  }
}
